import type {
  ErroDaSimulacao,
  IntencaoDeComando,
  NegociacaoSimulacaoState,
  TipoDeComando,
} from '../types';

/**
 * A intenção compara o corpo serializado inteiro: colisões de um resumo poderiam reutilizar
 * a chave de outro pedido.
 */
const assinaturaDoCorpo = (corpo: unknown): string => JSON.stringify(corpo ?? null);

/** Clique novo da pessoa: chave nova, mesmo que o corpo repita o da intenção anterior. */
export const intencaoNova = (corpo: unknown): IntencaoDeComando => ({
  chave: crypto.randomUUID(),
  assinatura: assinaturaDoCorpo(corpo),
});

/**
 * O "Tentar novamente" da mesma intenção: reaproveita a chave anterior quando o corpo é o mesmo,
 * para o core devolver o resultado já gravado em vez de criar outra simulação ou gravar a
 * mensagem de novo (CA-4, CA-9, CA-25). Se o corpo mudou, a intenção é outra, e a chave também.
 */
export const intencaoReaproveitavel = (
  intencoes: NegociacaoSimulacaoState['intencoes'],
  tipo: TipoDeComando,
  corpo: unknown,
): IntencaoDeComando => {
  const anterior = intencoes[tipo];
  if (anterior?.assinatura === assinaturaDoCorpo(corpo)) return anterior;
  return intencaoNova(corpo);
};

/**
 * Rede caída, sessão expirada ou 5xx: o pedido pode ter chegado e sido gravado no core. Só nesse
 * caso a próxima tentativa precisa da mesma chave; uma recusa 4xx é desfecho conhecido. Erro com
 * `comandoId` também é: o core fechou o comando como FALHOU, e a mesma chave só devolveria o mesmo
 * erro para sempre (comandoIdempotente.ts, `situacaoDoExistente`).
 */
export const desfechoDesconhecido = (erro: ErroDaSimulacao | null): boolean =>
  erro !== null && erro.comandoId === null && (erro.status === 0 || erro.status >= 500);
